import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ISubscription } from "rxjs/Subscription";
import { environment } from '../../shared/config/app-config';
import { CallService, FormSessionCanDeactivate, JwtService, PatientService, User, UserService } from '../../shared';
import { ThreadlistComponent } from './threadlist/threadlist.component';

@Component({
  selector: 'app-messagehosp',
  templateUrl: './messagehosp.component.html',
  styleUrls: ['./messagehosp.component.css']
})

export class MessagehospComponent extends FormSessionCanDeactivate {
  patswfid: any;
  msginfo: any;
  pswActive: any;
  msgload: boolean = false
  messages: any = {
    'messages': [],
    'term': ''
  };
  setMode: any = 'active';
  CurrentUser: User;
  subscription: ISubscription;
  showloder: boolean = true
  @ViewChild(ThreadlistComponent) child
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private patientService: PatientService,
    private toast: ToastrService,
    private jwtService: JwtService,
    private callService: CallService
  ) {
    super();
    this.subscription = callService.messagescomponentMethodCalled$.subscribe(
      () => {
        //this.temp_var = false;
        this.ngOnInit()
      }
    );
  }

  getPatientDatamode() {
    this.showloder = true
    this.messages.messages = []
    this.messages.term = ''
    this.getccmessage(this.allMessagePat)
  }

  ngOnDestroy() {
    // alert("Destroy Calling Here");
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }

  }


  ngOnInit() {
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )
    this.messages = {
      'messages': [],
      'term': '',
      'menustatus': ''
    };
    this.getmenu()
    this.getmessage(this.setMode)

  }
  getmenu() {
    this.userService.postuserinfoid('0', this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          let menu = data[1].menu;

          if (menu) {
            for (var i = 0; i < menu.length; i++) {
              if (menu[i].refName == 'PAT_TWOWAYMESSAGE') {
                this.messages.menustatus = menu[i].status

              }
            }
          }
        })


  }
  allMessagePat: any = []
  getmessage(mode) {
    this.messages.messages = []
    this.showloder = true
    this.patientService.getccmessages(this.CurrentUser.item.userAccountId, mode)
      .subscribe(
        data => {
          if (data) {
            this.allMessagePat = data
            this.getccmessage(data)
          }
          else {
            this.messages = undefined;
          }
        }

      );
  }
  getccmessage(data) {

    this.messages.messages = data
    this.showloder = false
  }
  receiveMessage($event) {
    this.patswfid = $event.patientSwfId
    let mode = 'C'
    this.patientService.getccmessagesinfo($event.patientSwfId, mode)
      .subscribe(
        data => {
          this.msginfo = data;
          this.msgload = true
          this.pswActive = $event.pswIsActive
          this.messages.messages.forEach(element => {
            if ($event.patientSwfId == element.patientSwfId)
              element.unReadMsgCount = 0
          });
          this.getmsgcount()
        }

      );
  }

  getmsgcount() {
    if (window.localStorage['startdate'] && window.localStorage['enddate']) {
      this.patientService.countrange(this.CurrentUser.item.userAccountId, window.localStorage['startdate'], window.localStorage['enddate'])
        .subscribe(
          data => {
            this.CurrentUser.item.msgcount = data.messageCount;
          }
        );
    } else {
      this.patientService.countrange(this.CurrentUser.item.userAccountId, 'N', 'N')
        .subscribe(
          data => {
            this.CurrentUser.item.msgcount = data.messageCount;
          })
    }
  }
  public timealert = environment.timelimit;
  submitmsg(event) {
    if (!event.portal) {
      this.patientService.savemsg(event)
        .subscribe(
          data => {

            this.toast.success(data.message, '', {
              timeOut: this.timealert
            });
            this.userService.logAudit('saveTwoWayMessageSentByCc', 0).subscribe(data => { })
            this.receiveMessage(event)

          }
        );
    } else {
      this.patientService.postattachment(event.postimg, event.portal)
        .subscribe(
          data => {
            if (data.status == 'success') {
              this.toast.success(data.message, '', {
                timeOut: this.timealert
              });
              this.userService.logAudit('saveTwoWayMessageSentByCc', 0).subscribe(data => { })
              this.receiveMessage(event)
            } else {
              this.toast.error(data.message, '', {
                timeOut: this.timealert
              });
            }
          }
        );
    }
  }

}






